import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79844400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-main" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "mian" }
const _hoisted_4 = { class: "sub-menu" }
const _hoisted_5 = { class: "mian-content" }
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { key: 1 }

import { computed, ref } from 'vue';
import SubMenu from '@/components/AppLayout/SubMenu.vue'
import LayoutHeader from '@/components/AppLayout/LayoutHeader.vue'
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const collapsed = ref<boolean>(false)
const toggleCollapsed = () => {
  collapsed.value = !collapsed.value;
};
const userRoute = useRoute() // 当前路由信息
// 根据路由 返回面包屑
const breadcrumbList = computed<any[]>(() => {
  return userRoute.meta.breadcrumb as any[] ?? []
})
//#f2f2f2

return (_ctx: any,_cache: any) => {
  const _component_MenuUnfoldOutlined = _resolveComponent("MenuUnfoldOutlined")!
  const _component_MenuFoldOutlined = _resolveComponent("MenuFoldOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LayoutHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SubMenu, { collapsed: collapsed.value }, null, 8, ["collapsed"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "collapsed",
            onClick: toggleCollapsed
          }, [
            (collapsed.value)
              ? (_openBlock(), _createBlock(_component_MenuUnfoldOutlined, { key: 0 }))
              : (_openBlock(), _createBlock(_component_MenuFoldOutlined, { key: 1 }))
          ]),
          _createVNode(_component_a_breadcrumb, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbList), (item, index) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    (item.path)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: item.path
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.name), 1))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_card, { class: "card-flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, {
              key: _ctx.$route.fullPath
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})